import { SVGProps } from 'react';

const DashboardIcon = ({
  height = '24px',
  width = '24px',
  strokeWidth = '2',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 24 24'
    strokeWidth={strokeWidth}
    {...props}
  >
    <g transform='translate(0.04 -0.027)'>
      <path
        d='M11.88,2.1,2.07,9.94A.22.22,0,0,0,2,10.1l-.08,9.76a2,2,0,0,0,2,2L20,22a2,2,0,0,0,2-2V10.1a.21.21,0,0,0-.08-.16L12.12,2.1A.18.18,0,0,0,11.88,2.1Z'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        fillRule='evenodd'
      />
      <line
        x1='19.54'
        transform='translate(2.46 11)'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
      />
    </g>
  </svg>
);

export default DashboardIcon;
